import React, {Component} from 'react'
import styled from "styled-components"
import {DESKTOP_BREAKPOINT} from "manager/views/components/Settlement/constants"

const HrWrapper = styled.div`
  background-color: white;
  margin-bottom: ${props => props.marginBottom || '0'};
  @media screen and ${DESKTOP_BREAKPOINT} {
    display: block;
    padding: 0 24px;
  }
`

const Hr = styled.div`
  border-top: 1px solid #D9D9D9;
`

export default class SettlementFormHr extends Component {
  render() {
    const {marginBottom} = this.props
    return (
      <HrWrapper marginBottom={marginBottom}>
        <Hr/>
      </HrWrapper>
    )
  }
}
